import EditRequirementForm from "../../features/CRUD/crudRequirementList/editRequirement/EditRequirement"


const EditCRUDRequirement  = () => {
  return (
    <div>
          <EditRequirementForm/>
    </div>
  )
}

export default EditCRUDRequirement
